import ContainerWithSteps from 'components/UI/Container/ContainerWithSteps'
import Biometry from 'components/views/Biometry'
import { useGenerateQRLink } from 'hooks/useGenerateQRLink'

const DigitalSignPage = () => {
  const qrValue = useGenerateQRLink()

  return (
    <ContainerWithSteps>
      <div>
        <Biometry qrValue={qrValue} />
      </div>
    </ContainerWithSteps>
  )
}

export default DigitalSignPage
